// Scroll Global Vars
// ----------------------------------------

let SCROLL = {
	isDisabled: false,
	scrollbarWidth: getScrollbarWidth()
};

$WINDOW.on('resize', () => {
	SCROLL.scrollbarWidth = getScrollbarWidth();
});

// Scroll Utilities
// ----------------------------------------

function getScrollbarWidth() {
	return window.innerWidth - $BODY[0].clientWidth;
}

function toggleScroll() {
	if (SCROLL.isDisabled) {
		enableScroll();
	} else {
		disableScroll();
	}
}

function disableScroll() {
	$BODY.css({
		'overflow': 'hidden',
		'padding-right': `${SCROLL.scrollbarWidth}px`
	});

	// Add a calculated width to elements with position:fixed
	// This prevents the content form jumping when the scrollbar is removed
	$('[data-will-fix]').each(function() {
		const $this = $(this);

		if ($this.css('position') == 'fixed') $this.css('width', `calc(100% - ${SCROLL.scrollbarWidth}px)`);
	});

	SCROLL.isDisabled = true;
}

function enableScroll() {
	$BODY.css({
		'overflow': '',
		'padding-right': ''
	});

	// Remove calculated widths
	$('[data-will-fix]').each(function() {
		const $this = $(this);

		if ($this.css('position') == 'fixed') $this.css('width', '');
	});

	SCROLL.isDisabled = false;
}
